import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import {
  QrList,
  QrModal,
  QrFilter,
  QrDetails,
  SerialNumberList,
  SerialNumberDetailsType,
  QrListingQueryParameters,
  SerialNumberListingQueryParameters,
  TransactionDetails,
  SKUListing,
  SKUListingQueryParameters,
} from "./types";

export const qrInitialstate: QrModal = {
  qrList: {
    data: [],
    total: 0,
    pageNo: 0,
    totalPage: 0,
    nextHit: 0,
    limit: 0,
  },
  qrListingQueryParameters: {
    pageNo: 1,
    limit: 10,
    searchKey: "",
  },
  serialNumberListingQueryParameters: {
    pageNo: 1,
    limit: 10,
  },

  qrFilter: {
    status: [],
    toDate: null,
    fromDate: null,
  },

  qrDetails: {
    _id: "",
    orderId: "",
    createdAt: "",
    totalPrice: 0,
    transactionId: "",
    fulfilledStatus: "",
    isBatchesLinked: false,
    totalRollQuantity: 0,
    orderStatus: "",
  },

  serialNumberList: {
    data: [],
    total: 0,
    pageNo: 1,
    totalPage: 0,
    nextHit: 0,
    limit: 6,
  },

  serialNumberDetails: {
    _id: "",
    orderId: "",
    totalPrice: 0,
    skuDetails: [],
    batchesData: [],
    trackingId: "",
    transactionId: "",
    totalRollQuantity: 0,
    batchesLinkedIds: [],
    totalSerialQuantity: 0,
  },

  transactionDetails: {
    _id: "",
    totalPrice: 0,
    totalRollQuantity: 0,
    totalSerialQuantity: 0,
    orderId: "",
    transactionId: "",
    createdAt: "",
    skuDetails: [],
  },

  skuListing: {
    data: [],
    total: 0,
    pageNo: 1,
    totalPage: 0,
    nextHit: 0,
    limit: 10,
  },

  skuListingQueryParameters: {
    pageNo: 1,
    limit: 10,
  },

  dateRange: undefined,
};
const QrCodeModuleSlice = createSlice({
  name: "qr-code-purchasing",
  initialState: qrInitialstate,
  reducers: {
    setQrListingData: (state: QrModal, action: PayloadAction<QrList>) => {
      state.qrList = { ...action.payload };
    },
    setSerialNumberListingData: (
      state: QrModal,
      action: PayloadAction<SerialNumberList>,
    ) => {
      state.serialNumberList = { ...action.payload };
    },
    setQrListingQueryParameters: (
      state: QrModal,
      action: PayloadAction<QrListingQueryParameters>,
    ) => {
      state.qrListingQueryParameters = { ...action.payload };
    },
    setSerialListingQueryParameters: (
      state: QrModal,
      action: PayloadAction<SerialNumberListingQueryParameters>,
    ) => {
      state.serialNumberListingQueryParameters = { ...action.payload };
    },
    setQrDetails: (state: QrModal, action: PayloadAction<QrDetails>) => {
      state.qrDetails = action.payload;
    },

    setQrFilter: (state: QrModal, action: PayloadAction<QrFilter>) => {
      state.qrFilter = action.payload;
    },

    setDateRange: (
      state: QrModal,
      action: PayloadAction<[Date, Date] | undefined>,
    ) => {
      state.dateRange = action.payload;
    },

    setSerialNumberDetails: (
      state: QrModal,
      action: PayloadAction<SerialNumberDetailsType>,
    ) => {
      state.serialNumberDetails = action.payload;
    },

    setTransactionDetails: (
      state: QrModal,
      action: PayloadAction<TransactionDetails>,
    ) => {
      state.transactionDetails = action.payload;
    },

    setSKUListingData: (state: QrModal, action: PayloadAction<SKUListing>) => {
      state.skuListing = { ...action.payload };
    },

    setSKUListingQueryParameters: (
      state: QrModal,
      action: PayloadAction<SKUListingQueryParameters>,
    ) => {
      state.skuListingQueryParameters = { ...action.payload };
    },
  },
});

export const {
  setQrFilter,
  setQrDetails,
  setDateRange,
  setQrListingData,
  setTransactionDetails,
  setSerialNumberDetails,
  setSerialNumberListingData,
  setQrListingQueryParameters,
  setSerialListingQueryParameters,
  setSKUListingData,
  setSKUListingQueryParameters,
} = QrCodeModuleSlice.actions;
export default QrCodeModuleSlice.reducer;
